// values need to be lowercase
export enum Stages {
  LOCAL = 'local',
  DEVELOP = 'dev',
  TEST = 'test',
  INT = 'int',
  PPROD = 'pprod',
  PROD = 'prod',
}
